
import React from 'react';
import style from './style.module.css';

const HistoryItem = props => {

    const description = () => {
        let result = '';

        if (props.itemType === 'points') {
            if (props.data.value && props.data.value >= 33) result = 'Bronze';
            if (props.data.value && props.data.value >= 66) result = 'Silver';
            if (props.data.value && props.data.value >= 100) result = 'Gold';
        }

        if (props.itemType === 'steps') {
            if (props.data.value && props.data.value >= 3300) result = 'Bronze';
            if (props.data.value && props.data.value >= 6600) result = 'Silver';
            if (props.data.value && props.data.value >= 10000) result = 'Gold';
        }

        if (!result.length) return 'Keep going!';
        return 'On track for ' + result + '!';
    };

    const appearance = () => {
        let result = '';

        if (props.itemType === 'points') {
            if (props.data.value && props.data.value >= 33) result = 'g3';
            if (props.data.value && props.data.value >= 66) result = 'g2';
            if (props.data.value && props.data.value >= 100) result = 'g1';
        }

        if (props.itemType === 'steps') {
            if (props.data.value && props.data.value >= 3300) result = 'g3';
            if (props.data.value && props.data.value >= 6600) result = 'g2';
            if (props.data.value && props.data.value >= 10000) result = 'g1';
        }

        if (!result.length) return 'g4';
        return result;
    }

    return (
        <div className={style.container}>
            <div className={style.Item + ' ' + style[appearance()]} onClick={props.onSelect}>
                <div className={style.info}>
                    <div className={style.title}>{(new Date(props.data.date.split('T')[0] + 'T00:00:00.000' + props.data.date.split('-')[1])).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</div>
                    <div className={style.description}>
                        <div className={style.descriptionLabel}>{description()}</div>
                        {/* <div className={style.iconInactive} /> */}
                    </div>
                    {/* {itemData.description && itemData.description.length ? <div className={style.description}>{itemData.description}</div> : null} */}
                </div>
                <div className={style.rank}>
                    <div className={style.value}>{props.data.value.toLocaleString()}</div>
                    <div className={style.metric}>{props.itemType}</div>
                </div>
            </div>
        </div>


        // <div className={style.Item + ' ' + style['g4']} onClick={props.onSelect}>
        //     <div className={style.info}>
        //         <div className={style.title}>{props.data.value.toLocaleString() + ' ' + props.itemType}</div>
        //         <div className={style.description}>{'on ' + (new Date(props.data.date.split('T')[0] + 'T00:00:00.000' + props.data.date.split('-')[1])).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</div>
        //     </div>
        // </div>
    );

};

export default HistoryItem;
